import React from 'react'
import './programs.css'
import program_logo_1 from "../../assets/program-1.png"
import program_logo_2 from "../../assets/program-2.png"
import program_logo_3 from "../../assets/program-3.png"
import caption_logo_1 from "../../assets/program-icon-1.png"
import caption_logo_2 from "../../assets/program-icon-2.png"
import caption_logo_3 from "../../assets/program-icon-3.png"



function Programs() {
    return (
        <div className='programs' id='program'>
            <div className='program'>
                <img src={program_logo_1} alt='' />
                <div className='caption'>
                    <img src={caption_logo_1} alt=''/>
                    <p>Graduation Degree</p>
                </div>
            </div>
            <div className='program'>
                <img src={program_logo_2} alt='' />
                <div className='caption'>
                    <img src={caption_logo_2} alt=''/>
                    <p>Master Degree</p>
                </div>
            </div>
            <div className='program'>   
                <img src={program_logo_3} alt='' />
                <div className='caption'>
                    <img src={caption_logo_3} alt=''/>
                    <p>Post Graduation</p>
                </div>
            </div>
        </div>
    )
}

export default Programs



